export default __webpack_public_path__ + "static/es-b5f59512333fba96e50494f4c615992f.svg";